import { render } from "./Empresas.vue?vue&type=template&id=058f97dd&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"

import "./Empresas.vue?vue&type=style&index=0&id=058f97dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-058f97dd"

export default script